import React, { useEffect, useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { COLORS } from "../../constants";

const MobileSiteBottombar = ({
  user,
  isAuthenticated,
  isLoading,
  toggleCategories,
}) => {
  const dropDownRef = useRef(null);

  // Handle outside clicks and Escape key to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        // No state to manage here since drawers are controlled by MobileHeader
      }
    };

    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        // No state to manage here since drawers are controlled by MobileHeader
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
  }, []);

  if (isLoading) return null;

  return (
    <>
      {/* Container as a button with yellow background */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: COLORS.themeYellow,
        }}
      >
        <Button
          onClick={toggleCategories}
          sx={{
            width: "100%",
            color: COLORS.themeBlack,
            fontSize: "var(--font-size-xxs)",
            fontFamily: "Rubik, sans-serif",
            fontWeight: 500,
            textTransform: "uppercase",
            borderRadius: 0,
            display: "flex",
            alignItems: "center",
            lineHeight: "1.6875rem",
            boxSizing: "border-box",
            "&:hover": {
              backgroundColor: COLORS.themeYellow,
              color: COLORS.themeBlack,
            },
          }}
          ref={dropDownRef}
        >
          {/* Category icon on the left */}
          <CategoryIcon sx={{ color: COLORS.themeBlack, mr: 1 }} />
          Shop by Category
          {/* ChevronRight icon on the right */}
          <Box sx={{ marginLeft: "auto" }}>
            <ChevronRightIcon sx={{ color: COLORS.themeBlack, mt: 1 }} />
          </Box>
        </Button>
      </Box>
    </>
  );
};

export default MobileSiteBottombar;
